// External libraries
import React from 'react';
import { bool, string } from 'prop-types';

// Internal modules
import { logTermClick } from './utils';
import { TERMS_MAP } from './constants';
import { TermsLink } from '@/components/Common';
import { buildTermsUrl, getContent, getNestedContentKeys } from '@/lib';

const getTermsLinks = (termsKey, isSubmitting) => {
  const termsLinks = getNestedContentKeys(termsKey);
  if (!Array.isArray(termsLinks)) {
    return {};
  }

  return termsLinks.reduce((termsObj, link) => {
    termsObj[link] =
      link === 'brTag' ? (
        <br />
      ) : (
        <TermLink
          isSubmitting={isSubmitting}
          linkName={link}
          {...TERMS_MAP[link]}
        />
      );
    return termsObj;
  }, {});
};

const TermLink = props => {
  const { contentKey, isSubmitting, ...rest } = props;

  return (
    <TermsLink
      clickHandler={() => logTermClick(contentKey)}
      href={isSubmitting ? null : buildTermsUrl(rest)}
      text={getContent(`compliance.${contentKey}`)}
    />
  );
};

TermLink.propTypes = {
  contentKey: string.isRequired,
  isSubmitting: bool,
  path: string.isRequired,
};

export { getTermsLinks, TermLink };
